.card {
  display: flex;
  flex-direction: column;
  background: var(--adl-surface-container);
  padding-bottom: var(--mantine-spacing-lg);
}

/* Horizontal layout (rate browser): header and selectors share one row, inside a bordered box. */
.cardHorizontal {
  flex-direction: row;
  align-items: center;
  gap: var(--mantine-spacing-sm);
  border: 1px solid var(--adl-border-light);
  border-radius: var(--mantine-radius-sm);
  padding: var(--mantine-spacing-sm) var(--mantine-spacing-sm) var(--mantine-spacing-sm) var(--mantine-spacing-1_5);
}

.header {
  display: flex;
  align-items: center;
  gap: var(--mantine-spacing-sm);
  padding-bottom: var(--mantine-spacing-sm);
}

.cardHorizontal .header {
  flex: 1;
  min-width: 0;
  gap: var(--mantine-spacing-1_5);
  padding-bottom: 0;
}

/* Stacks the carrier name above the View Details link in the horizontal layout. */
.carrierBlock {
  display: flex;
  flex: 1;
  min-width: 0;
  flex-direction: column;
  align-items: flex-start;
}

.logoBox {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  background: var(--adl-surface-container);
  overflow: hidden;
}

.logoImage {
  width: 40px;
  height: 40px;
  border-radius: 2px;
  object-fit: contain;
}

.logoInitials {
  font-size: 12px;
  font-weight: 600;
  color: var(--adl-text-secondary);
}

.carrierName {
  flex: 1;
  font-weight: 600;
  color: var(--adl-text-primary);
}

.selectors {
  display: flex;
  align-items: flex-start;
  gap: var(--mantine-spacing-sm);
  width: 100%;
}

/* Horizontal layout: selectors hug the right side as two equal fixed-width columns.
   Grid tracks size the children, overriding the base `.selector { flex: 1 }` rule. */
.selectorsHorizontal {
  display: grid;
  grid-template-columns: repeat(2, 150px);
  width: auto;
  flex-shrink: 0;
}
